// extracted by mini-css-extract-plugin
module.exports = {"container":"AverageRating_container__Ya0CN","ratingText":"AverageRating_ratingText__CKZlo"};